import {
  apiRequest,
  P3KuploadSKP3K,
  P3KdetailCP3K,
  masterRankPppk,
  masterSignatoryOfficial,
  masterDocumentType,
  p3kDownloadSPMT,
  p3kDownloadContract,
} from "../../../../../services/adapters/kepegawaian/P3KService";

class UploadSKRepository {
  fetchUploadSk = async (query) => {
    return await apiRequest(
      "post",
      P3KuploadSKP3K,
      {
        body: query,
      },
      true
    );
  };

  fetchDownloadSPMT = async (query) => {
    return await apiRequest(
      "get",
      p3kDownloadSPMT,
      {
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      P3KdetailCP3K,
      {
        params: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      masterRankPppk,
      {
        params: query,
      },
      true
    );
  };

  fetchSignatoryOfficial = async (query) => {
    return await apiRequest(
      "get",
      masterSignatoryOfficial,
      {
        params: query,
      },
      true
    );
  };

  fetchDocumentType = async (query) => {
    return await apiRequest(
      "get",
      masterDocumentType,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadContract = async (query) => {
    return await apiRequest(
      "get",
      p3kDownloadContract,
      {
        params: query,
      },
      true
    );
  };
}

export default UploadSKRepository;
